import {
    updateHeaderShoppingBagCounts
} from '../international/_intl';
import {
    toolbarInit
} from './_toolbarInit';
import {
    showMyDillardsWelcome
} from './_showMyDillardsWelcome';

export const myDillardsBar = () => {
    showMyDillardsWelcome();
    toolbarInit();
    updateHeaderShoppingBagCounts();
};
